var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarFilled = function SvgStarFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.36 1.855c-.547-1.14-2.174-1.14-2.722 0L8.27 6.785s-.003.004-.007.004l-5.45.714c-1.256.164-1.768 1.713-.84 2.587l3.984 3.757c.002.001.002.003.002.003l-1 5.367c-.234 1.252 1.09 2.198 2.2 1.6l4.835-2.606a.012.012 0 0 1 .01 0l4.836 2.606c1.109.598 2.434-.348 2.2-1.6l-1-5.367s0-.002.002-.003l3.984-3.757c.927-.874.415-2.423-.84-2.587l-5.45-.714c-.004 0-.007-.004-.007-.004l-2.369-4.93Z"
  })));
};
export default SvgStarFilled;